// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'eafed9fd015ea1e9879b965de7e8c04d49634536';
export const BUILD_NUMBER = '211';
export const BUILD_TIMESTAMP = '2026-07-28T11:31:42.615Z';
